export default {
    name: 'threat-monitoring',
    components: {
    },
    props: [],
    data() {
        return {
            userInfo: {
                profile: {}
            },
            userProfile: {},
            questionnaire: {},
            isSubscribed: false,
            dataBreaches: [],
            toggleDrawer: true,
            isMobile: false
        }
    },
    computed: {
        dataBreachesGroupedByEmail() {
            var userBreachesDictionary = new Object();

            this.dataBreaches.forEach((item) => {
                if (!userBreachesDictionary[item.userEmail.email]) {
                    userBreachesDictionary[item.userEmail.email] = [item];
                } else {
                    userBreachesDictionary[item.userEmail.email].push(item);
                }
            });

            return userBreachesDictionary;
        },
        dataBreachesGroupedByBreach() {
            var userBreachesDictionary = new Object();

            this.dataBreaches.forEach((item) => {
                if (!userBreachesDictionary[item.dataBreachId]) {
                    userBreachesDictionary[item.dataBreachId] = [item];
                } else {
                    userBreachesDictionary[item.dataBreachId].push(item);
                }
            });

            return userBreachesDictionary;
        }
    },
    mounted() {
        this._onResize()
        this.$state.set('loading', true);
        this._loadDataBreachesData();
    },
    watch: {
    },
    methods: {
        async _loadDataBreachesData() {
            let self = this;

            await self.$authManager.getUser(function (user) {
                self.userInfo = user;
                self.$api.getUser(user).then(function (result) {
                    self.userProfile = result
                });

                self.$api.getUserInteraction(user).then(function (interactionInfo) {
                    self.isSubscribed = interactionInfo.isThreadMonitoringSubscribed;
                });

                self.$api.getDataBreaches(user).then(function (result) {
                    self.dataBreaches = result;
                    self._sycAppData();
                });

                self.$api.getQuestionnaire(user).then(function (questionnaire) {
                    self.questionnaire = questionnaire;
                    self._sycAppData();
                });
            });
        },

        async _markAsRead(breach) {
            let self = this,
                data = {
                    userBreachId: breach.id,
                    isRead: breach.isRead.toString()
                };

            self.$state.set("loading", true);
            self.$api.dataBreachesMarkAsRead(self.userInfo, data, function (response) {
                if (response && response.status == 200) {
                    self.dataBreaches = response.data;
                    self._sycAppData();
                }

                self.$state.set("loading", false);
            });
        },

        async _markAsPasswordChahnged(breach) {
            let self = this,
                data = {
                    userBreachId: breach.id,
                    isPasswordChanged: breach.isPasswordChanged.toString()
                };

            self.$state.set("loading", true);
            self.$api.dataBreachesMarkAsPasswordChanged(self.userInfo, data, function (response) {
                if (response && response.status == 200) {
                    self.dataBreaches = response.data;
                    self._sycAppData();
                }

                self.$state.set("loading", false);
            });
        },

        async _markAsSubscribed() {
            let self = this,
                data = {
                    userId: self.userInfo.profile.sub,
                    isSubscribed: self.isSubscribed.toString()
                };

            self.$state.set("loading", true);
            self.$api.dataBreachesMarkAsSubscribed(self.userInfo, data, function (response) {
                if (response && response.status == 200) {
                    self._sycAppData();
                }

                self.$state.set("loading", false);
            });
        },

        _sycAppData() {
            let self = this;

            self.$state.set('loading', false);
            self.$state.set('questionnaire', self.questionnaire || {});
        },

        _onResize() {
            this.isMobile = window.innerWidth <= 565; 
        },

        _getLogoUrl(logoUrl) {
            if (logoUrl && logoUrl.toLowerCase().indexOf('/email.') != -1) {
                return require('../../assets/threatmonitoring/logo-email.svg');
            } else if (logoUrl && logoUrl.toLowerCase().indexOf('/list.') != -1) {
                return require('../../assets/threatmonitoring/logo-list.svg');
            } else {
                return logoUrl;
            }
        }
    }
}
